export default __webpack_public_path__ + "static/media/insta-5.765cd532.jpg";